/**
 * Format a date string to DD-MM-YYYY display format.
 * Accepts ISO dates (YYYY-MM-DD) or ISO datetimes (YYYY-MM-DDTHH:mm:ss).
 * Returns empty string for falsy input.
 */
export function formatDate(dateStr) {
  if (!dateStr) return '';
  // Parse YYYY-MM-DD directly (avoids timezone issues with new Date())
  const match = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    return `${match[3]}-${match[2]}-${match[1]}`;
  }
  return String(dateStr);
}

/**
 * Format a 24-hour time string (HH:MM) to 12-hour AM/PM format.
 * E.g., "14:00" → "2:00 PM", "09:30" → "9:30 AM"
 */
export function formatTime(timeStr) {
  if (!timeStr) return '';
  const match = String(timeStr).match(/^(\d{1,2}):(\d{2})/);
  if (!match) return timeStr;
  let h = parseInt(match[1], 10);
  const m = match[2];
  const ampm = h >= 12 ? 'PM' : 'AM';
  if (h === 0) h = 12;
  else if (h > 12) h -= 12;
  return `${h}:${m} ${ampm}`;
}
